<template>
  <div class="o-page__content u-pt-small">
    <div class="container-fluid u-mb-medium">
      <div class="row">
        <div class="col-12 col-xl-12">
          <h1 class="u-h3">Dashboard</h1>
          <div style="display: inline-block; float: right; margin-top: -40px">
            <el-date-picker
              v-model="daterange"
              type="daterange"
              format="dd MMM yyyy"
              value-format="yyyy-MM-dd"
              start-placeholder="Start"
              @change="refetch"
              :picker-options="datePickerOptions"
              end-placeholder="End"
            >
            </el-date-picker>
          </div>
        </div>
      </div>
      <div class="row u-mt-medium">
        <div class="col-12">
          <div class="c-card u-p-small">
            <div
              class="c-card__header c-card__header--transparent o-line u-p-zero u-pb-small"
            >
              <h5 class="c-card__title">Rating BNI Region</h5>
              <div class="c-card__meta">
                <div class="custom_toolbar">
                  <Select2
                    v-model="params.region"
                    :options="regions"
                    :settings="{ width: '150px', placeholder: 'Region' }"
                    @change="myChangeEvent($event)"
                  />
                  <Select2
                    v-model="params.branch"
                    :options="branches"
                    :settings="{ width: '150px', placeholder: 'Branch' }"
                    @change="myChangeEvent2($event)"
                  />
                  <Select2
                    v-model="params.outlet"
                    :options="outlets"
                    :settings="{ width: '150px', placeholder: 'Outlet' }"
                    @change="myChangeEvent3($event)"
                  />
                  <el-button
                    size="mini"
                    icon="el-icon-refresh-left"
                    @click="reset"
                    >Reset</el-button
                  >
                  <el-button size="mini" icon="el-icon-download"></el-button>
                </div>
              </div>
            </div>
            <div
              style="width: 100%; overflow-x: scroll; overflow-y: hidden; height: 350px"
            >
              <GChart
                v-loading="loading"
                type="ColumnChart"
                :data="chartData"
                :options="chartOptions"
                :events="chartEvents"
                ref="gChart"
              />
            </div>
            <!-- <column-chart v-loading="loading" :dataset="{borderWidth: 0, backgroundColor: '#4477ff'}" :data="rows"></column-chart> -->
          </div>
          <div class="c-card u-p-small u-mt-small">
            <div
              class="c-card__header c-card__header--transparent o-line u-p-zero u-pb-small"
            >
              <h5 class="c-card__title">Rating BNI Category</h5>
              <div class="c-card__meta">
                <div class="custom_toolbar">
                  <Select2
                    v-model="params.region"
                    :options="regions"
                    :settings="{ width: '150px', placeholder: 'Region' }"
                    @change="myChangeEvent($event)"
                  />
                  <Select2
                    v-model="params.branch"
                    :options="branches"
                    :settings="{ width: '150px', placeholder: 'Branch' }"
                    @change="myChangeEvent2($event)"
                  />
                  <Select2
                    v-model="params.outlet"
                    :options="outlets"
                    :settings="{ width: '150px', placeholder: 'Outlet' }"
                    @change="myChangeEvent3($event)"
                  />
                  <el-button
                    size="mini"
                    icon="el-icon-refresh-left"
                    @click="reset"
                    >Reset</el-button
                  >
                  <el-button size="mini" icon="el-icon-download"></el-button>
                </div>
              </div>
            </div>
            <div
              style="width: 100%; overflow-x: scroll; overflow-y: hidden; height: 350px"
            >
              <GChart
                v-loading="loading2"
                type="ColumnChart"
                :data="chartData2"
                :options="chartOptions2"
                :events="chartEvents"
                ref="gChart"
              />
            </div>
            <!-- <column-chart v-loading="loading" :dataset="{borderWidth: 0, backgroundColor: '#4477ff'}" :data="rows"></column-chart> -->
          </div>
        </div>

        <div class="col-6">
          <!-- Line chart by aspek -->
          <div class="c-card u-p-small u-mt-small">
            <div
              class="c-card__header c-card__header--transparent o-line u-p-zero u-pb-small"
            >
              <h5 class="c-card__title">Rating BNI Aspect</h5>
              <div class="c-card__meta">
                <div class="custom_toolbar_mini">
                  <Select2
                    v-model="params.region"
                    :options="regions"
                    :settings="{ width: '150px', placeholder: 'Region' }"
                    @change="myChangeEvent($event)"
                  />
                  <Select2
                    v-model="params.branch"
                    :options="branches"
                    :settings="{ width: '150px', placeholder: 'Branch' }"
                    @change="myChangeEvent2($event)"
                  />
                  <Select2
                    v-model="params.outlet"
                    :options="outlets"
                    :settings="{ width: '150px', placeholder: 'Outlet' }"
                    @change="myChangeEvent3($event)"
                  />
                  <el-button
                    size="mini"
                    icon="el-icon-refresh-left"
                    @click="reset"
                    >Reset</el-button
                  >
                  <el-button size="mini" icon="el-icon-download"></el-button>
                </div>
              </div>
            </div>
            <div
              style="width: 100%; overflow-x: scroll; overflow-y: hidden; height: 350px"
            >
              <GChart
                v-loading="loading_aspect_chart"
                type="ColumnChart"
                :data="aspectChartData"
                :options="aspectChartOptions"
                :events="chartEvents"
                ref="gChart"
              />
            </div>
            <!-- <column-chart v-loading="loading" :dataset="{borderWidth: 0, backgroundColor: '#4477ff'}" :data="rows"></column-chart> -->
          </div>
          <br>
          <div class="c-card u-p-small u-text-center">
            <!-- <h4>General</h4> -->
            <pie-chart
              suffix="%"
              :colors="['#71d467', '#ff910f']"
              :data="pieData"
            ></pie-chart>
            <small class="u-text-mute u-mt-small" style="display: block"
              >From {{ pieDataTotal }} Total Rating</small
            >
          </div>
          <div class="c-graph-card u-mt-small" v-if="dataTop">
            <h4 class="u-p-small">Top 10 Average Rate</h4>
            <div class="c-graph-card__footer u-p-zero">
              <div
                class="u-flex u-justify-between u-align-items-center u-border-bottom u-p-small"
                v-for="(item, index) in dataTop"
                :key="index"
              >
                <span class="u-text-small u-color-primary">
                  {{ item.name }}
                </span>

                <div class="u-text-right u-color-primary">
                  <el-rate
                    disabled
                    show-score
                    text-color="#ff9900"
                    score-template="{value}"
                    :value="parseFloat(item.avgRate.toFixed(2))"
                  ></el-rate>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-6">
          <!-- Line chart by fasilities -->
          <div class="c-card u-p-small u-mt-small">
            <div
              class="c-card__header c-card__header--transparent o-line u-p-zero u-pb-small"
            >
              <h5 class="c-card__title">Rating BNI Facility</h5>
              <div class="c-card__meta">
                <div class="custom_toolbar_mini">
                  <Select2
                    v-model="params.region"
                    :options="regions"
                    :settings="{ width: '150px', placeholder: 'Region' }"
                    @change="myChangeEvent($event)"
                  />
                  <Select2
                    v-model="params.branch"
                    :options="branches"
                    :settings="{ width: '150px', placeholder: 'Branch' }"
                    @change="myChangeEvent2($event)"
                  />
                  <Select2
                    v-model="params.outlet"
                    :options="outlets"
                    :settings="{ width: '150px', placeholder: 'Outlet' }"
                    @change="myChangeEvent3($event)"
                  />
                  <el-button
                    size="mini"
                    icon="el-icon-refresh-left"
                    @click="reset"
                    >Reset</el-button
                  >
                  <el-button size="mini" icon="el-icon-download"></el-button>
                </div>
              </div>
            </div>
            <div
              style="width: 100%; overflow-x: scroll; overflow-y: hidden; height: 350px"
            >
              <GChart
                v-loading="loading_facility_chart"
                type="ColumnChart"
                :data="facilityChartData"
                :options="facilityChartOptions"
                :events="chartEvents"
                ref="gChart"
              />
            </div>
            <!-- <column-chart v-loading="loading" :dataset="{borderWidth: 0, backgroundColor: '#4477ff'}" :data="rows"></column-chart> -->
          </div>

          <!-- Pie Chart negative review  -->
          <div class="c-card u-p-small u-mt-small">
            <div
              class="c-card__header c-card__header--transparent o-line u-p-zero u-pb-small"
            >
              <h5 class="c-card__title">Negative Review</h5>
              <div class="c-card__meta">
                <div class="custom_toolbar_mini">
                  <Select2
                    v-model="params.region"
                    :options="regions"
                    :settings="{ width: '150px', placeholder: 'Region' }"
                    @change="myChangeEvent($event)"
                  />
                  <Select2
                    v-model="params.branch"
                    :options="branches"
                    :settings="{ width: '150px', placeholder: 'Branch' }"
                    @change="myChangeEvent2($event)"
                  />
                  <Select2
                    v-model="params.outlet"
                    :options="outlets"
                    :settings="{ width: '150px', placeholder: 'Outlet' }"
                    @change="myChangeEvent3($event)"
                  />
                  <el-button
                    size="mini"
                    icon="el-icon-refresh-left"
                    @click="reset"
                    >Reset</el-button
                  >
                  <el-button size="mini" icon="el-icon-download"></el-button>
                </div>
              </div>
            </div>
            <div
              style="width: 100%; overflow-x: scroll; overflow-y: hidden; height: 400px"
            >
              <div
                class="c-card u-p-medium u-text-center negative-review-chart-warpper"
              >
                <pie-chart
                  :colors="['#dfe6e9', '#0984e3', '#55efc4']"
                  :data="dataChartNegativeReview"
                ></pie-chart>
                <!-- <small class="u-text-mute u-mt-small" style="display: block"
                  >From {{ dataChartNegativeReviewTotal }} Total Rating</small
                > -->
              </div>
              <div class="c-graph-card u-mt-small" v-if="dataTop">
                <h4 class="u-p-small">Top 10 Average Rate</h4>
                <div class="c-graph-card__footer u-p-zero">
                  <div
                    class="u-flex u-justify-between u-align-items-center u-border-bottom u-p-small"
                    v-for="(item, index) in dataChartNegativeReviewTop"
                    :key="index"
                  >
                    <span class="u-text-small u-color-primary">
                      {{ item.name }}
                    </span>

                    <div class="u-text-right u-color-primary">
                      <el-rate
                        disabled
                        show-score
                        text-color="#ff9900"
                        score-template="{value}"
                        :value="parseFloat(item.avgRate.toFixed(2))"
                      ></el-rate>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import api from "@/api/ratings";
import branches from "@/api/branches";
import regions from "@/api/regions";
import { GChart } from "vue-google-charts";
import Select2 from "v-select2-component";
import moment from "moment";
import outlets from "@/api/outlets";
import axios from "axios";
export default {
  name: "dashboard",
  components: {
    GChart,
    Select2,
  },
  data() {
    return {
      chartEvents: {
        select: () => {
          // const table = this.$refs.gChart.chartObject;
          // const selection = table.getSelection();
          // var row = selection[0].row;
          // this.params.region = this.regions[selection[0].row].id
          // this.fetchBranches()
          // this.fetch()
        },
      },
      daterange: [],
      chartData: [],
      chartData2: [],
      facilityChartData: [],
      aspectChartData: [],
      chartOptions: {
        annotations: {
          alwaysOutside: true,
          textStyle: {
            fontSize: 12,
            auraColor: "none",
            color: "#555",
          },
          boxStyle: {
            stroke: "#ccc",
            strokeWidth: 1,
            gradient: {
              color1: "#f3e5f5",
              color2: "#f3e5f5",
              x1: "0%",
              y1: "0%",
              x2: "100%",
              y2: "100%",
            },
          },
        },
        colors: ["#71d467", "#ff910f"],
        legend: { position: "none" },
        chartArea: {
          left: 50,
          top: 20,
          width: "100%",
          height: "100%",
          bottom: 80,
        },
        width: 65,
        bar: { groupWidth: 40 },
        height: 350,
        hAxis: {
          textStyle: {
            fontSize: 10, // or the number you want
          },
        },
        vAxis: {
          textStyle: {
            fontSize: 10, // or the number you want
          },
        },
        focusTarget: "category",
        tooltip: { isHtml: true },
      },
      chartOptions2: {
        annotations: {
          alwaysOutside: true,
          textStyle: {
            fontSize: 12,
            auraColor: "none",
            color: "#555",
          },
          boxStyle: {
            stroke: "#ccc",
            strokeWidth: 1,
            gradient: {
              color1: "#f3e5f5",
              color2: "#f3e5f5",
              x1: "0%",
              y1: "0%",
              x2: "100%",
              y2: "100%",
            },
          },
        },
        colors: ["#71d467", "#ff910f"],
        legend: { position: "none" },
        chartArea: {
          left: 50,
          top: 20,
          width: "100%",
          height: "100%",
          bottom: 80,
        },
        width: 65,
        bar: { groupWidth: 40 },
        height: 350,
        hAxis: {
          textStyle: {
            fontSize: 10, // or the number you want
          },
        },
        vAxis: {
          textStyle: {
            fontSize: 10, // or the number you want
          },
        },
        focusTarget: "category",
        tooltip: { isHtml: true },
      },
      facilityChartOptions: {
        annotations: {
          alwaysOutside: true,
          textStyle: {
            fontSize: 12,
            auraColor: "none",
            color: "#555",
          },
          boxStyle: {
            stroke: "#ccc",
            strokeWidth: 1,
            gradient: {
              color1: "#f3e5f5",
              color2: "#f3e5f5",
              x1: "0%",
              y1: "0%",
              x2: "100%",
              y2: "100%",
            },
          },
        },
        colors: ["#71d467", "#ff910f"],
        legend: { position: "none" },
        chartArea: {
          left: 50,
          top: 20,
          width: "100%",
          height: "100%",
          bottom: 80,
        },
        width: 65,
        bar: { groupWidth: 40 },
        height: 350,
        hAxis: {
          textStyle: {
            fontSize: 10, // or the number you want
          },
        },
        vAxis: {
          textStyle: {
            fontSize: 10, // or the number you want
          },
        },
        focusTarget: "category",
        tooltip: { isHtml: true },
      },
      aspectChartOptions: {
        annotations: {
          alwaysOutside: true,
          textStyle: {
            fontSize: 12,
            auraColor: "none",
            color: "#555",
          },
          boxStyle: {
            stroke: "#ccc",
            strokeWidth: 1,
            gradient: {
              color1: "#f3e5f5",
              color2: "#f3e5f5",
              x1: "0%",
              y1: "0%",
              x2: "100%",
              y2: "100%",
            },
          },
        },
        colors: ["#71d467", "#ff910f"],
        legend: { position: "none" },
        chartArea: {
          left: 50,
          top: 20,
          width: "100%",
          height: "100%",
          bottom: 80,
        },
        width: 65,
        bar: { groupWidth: 40 },
        height: 350,
        hAxis: {
          textStyle: {
            fontSize: 10, // or the number you want
          },
        },
        vAxis: {
          textStyle: {
            fontSize: 10, // or the number you want
          },
        },
        focusTarget: "category",
        tooltip: { isHtml: true },
      },
      datePickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      rows: [],
      loading: true,
      loading2: true,
      loading_facility_chart: true,
      loading_aspect_chart: true,
      pieData: [],
      pieDataTotal: 0,
      dataChartNegativeReview: [],
      dataChartNegativeReviewTotal: 0,
      loadingPie: true,
      loadingdataChartNegativeReview: true,
      regions: [],
      branches: [],
      outlets: [],
      params: {
        region: "",
        branch: "",
        outlet: "",
      },
      dataTop: null,
      dataChartNegativeReviewTop: null,
    };
  },
  mounted() {
    let end = new Date();
    var start = moment(start).subtract(1, "months")._d;
    // end = new Date(end)
    this.daterange = [start, end];

    // console.log(start)
    // console.log(end)

    this.fetchRegions();
    this.fetch();
    this.fetchGeneral();
    this.fetchByCategory();
    this.fetchByFacility();
    this.fetchByAspect();
    this.fetchNegativeReview();
    // this.fetchTop()
  },
  methods: {
    ...mapActions(["logout"]),
    createCustomHTMLContent(name, positive, negative) {
      return (
        '<div style="padding:10px 15px;">' +
        '<b style="white-space: nowrap;padding: 0 3px;">' +
        name +
        "</b><br/>" +
        '<table style="width: 100%; margin-top: 6px;" class="medals_layout">' +
        "<tr>" +
        '<td style="text-align:left;">Positive</td>' +
        '<td style="text-align:right;"><b>' +
        positive +
        "</b></td>" +
        "</tr>" +
        "<tr>" +
        '<td style="text-align:left;">Negative</td>' +
        '<td style="text-align:right;"><b>' +
        negative +
        "</b></td>" +
        "</tr>" +
        "<tr>" +
        "</table>" +
        "</div>"
      );
    },
    refetch() {
      this.fetch();
      this.fetchByCategory();
      this.fetchByFacility();
      this.fetchByAspect();
      this.fetchGeneral();
      this.fetchNegativeReview();
    },
    fetch() {
      this.loading = true;
      var self = this;
      axios
        .get(
          "https://api-dash.bniservicerating.com/v1/rating/report?startdate=" +
            moment(this.daterange[0]).format("YYYY-MM-DD") +
            "&enddate=" +
            moment(this.daterange[1]).format("YYYY-MM-DD") +
            "&outlet_code=" +
            this.params.outlet +
            "&branch_code=" +
            this.params.branch +
            "&region_code=" +
            this.params.region,
          {
            headers: {
              "x-api-key": "DBrbsrGFyoDFGI8XS1lDUhhL1W0XfkDmpnfAcrt",
              "x-access-token": localStorage.getItem("accessToken"),
            },
          }
        )
        // api.getRegion(this.params.region, this.params.branch, this.params.outlet, moment(this.daterange[0]).format('YYYY-MM-DD'), moment(this.daterange[1]).format('YYYY-MM-DD'))
        .then(function(response) {
          if (response.data.data.length > 0) {
            var data = [
              [
                "Name",
                "Positive",
                { type: "string", role: "annotation", p: { html: true } },
                "Negative",
                { type: "string", role: "annotation", p: { html: true } },
              ],
            ];
            if (response.data.data.length > 0) {
              if (!self.params.branch) {
                response.data.data.forEach((element) => {
                  data.push([
                    element.acronym.toUpperCase(),
                    parseInt(element.positive),
                    parseInt(element.positive),
                    parseInt(element.negative),
                    parseInt(element.negative),
                  ]);
                });
              } else {
                response.data.data.forEach((element) => {
                  data.push([
                    element.name.toUpperCase(),
                    parseInt(element.positive),
                    parseInt(element.positive),
                    parseInt(element.negative),
                    parseInt(element.negative),
                  ]);
                });
              }
              // self.rows = data
              self.chartOptions.width = data.length * 65;
              self.chartData = data;
              self.loading = false;
            } else {
              data.push(["No data", 0, 0]);
              self.chartData2 = data;
            }
          } else {
            // (self.chartData = []), alert("no data");
            self.loading = false;
          }
        })
        .catch(function(error) {
          console.log(error);
          if (error.response.status == 403) {
            self.logout();
          }
        });
    },
    fetchGeneral() {
      this.loadingPie = true;
      var self = this;
      axios
        .get(
          "https://api-dash.bniservicerating.com/v1/rating/total-chart?startdate=" +
            moment(this.daterange[0]).format("YYYY-MM-DD") +
            "&enddate=" +
            moment(this.daterange[1]).format("YYYY-MM-DD") +
            "&outlet_code=" +
            this.params.outlet +
            "&branch_code=" +
            this.params.branch +
            "&region_code=" +
            this.params.region,
          {
            headers: {
              "x-api-key": "DBrbsrGFyoDFGI8XS1lDUhhL1W0XfkDmpnfAcrt",
              "x-access-token": localStorage.getItem("accessToken"),
            },
          }
        )
        // api.general()
        .then(function(response) {
          var total =
            parseInt(response.data.data.positive) +
            parseInt(response.data.data.negative);
          var pos = (parseInt(response.data.data.positive) / total) * 100;
          var neg = (parseInt(response.data.data.negative) / total) * 100;
          self.pieData = [
            ["Positive", pos.toFixed(2)],
            ["Negative", neg.toFixed(2)],
          ];
          self.pieDataTotal = total.toLocaleString("ID");
          self.loadingPie = false;
        })
        .catch(function(error) {
          console.log(error);
          self.loadingPie = false;
          if (error.response.status == 403) {
            self.logout();
          }
        });
    },
    fetchTop() {
      var self = this;
      api
        .getTop()
        .then(function(response) {
          self.dataTop = response.data.data;
        })
        .catch(function(error) {
          console.log(error);
          if (error.response.status == 403) {
            self.logout();
          }
        });
    },

    fetchNegativeReview() {
      var self = this;
      axios
        .get(
          "https://api-dash.bniservicerating.com/v1/rating/negative-score-chart?startdate=" +
            moment(this.daterange[0]).format("YYYY-MM-DD") +
            "&enddate=" +
            moment(this.daterange[1]).format("YYYY-MM-DD") +
            "&outlet_code=" +
            this.params.outlet +
            "&branch_code=" +
            this.params.branch +
            "&region_code=" +
            this.params.region,
          {
            headers: {
              "x-api-key": "DBrbsrGFyoDFGI8XS1lDUhhL1W0XfkDmpnfAcrt",
              "x-access-token": localStorage.getItem("accessToken"),
            },
          }
        )
        .then(function(response) {
          console.log(response);
          var total = parseInt(response.data.data.total);
          var open = response.data.data.open;
          var follow_up = response.data.data.follow_up;
          var close = response.data.data.close;
          // var open = (parseInt(response.data.data.open) / total) * 100;
          // var follow_up = (parseInt(response.data.data.follow_up) / total) * 100;
          // var close = (parseInt(response.data.data.close) / total) * 100;
          self.dataChartNegativeReview = [
            ["Baru", open.toFixed(2)],
            ["On Progress", follow_up.toFixed(2)],
            ["Selesai", close.toFixed(2)],
          ];
          self.dataChartNegativeReviewTotal = total.toLocaleString("ID");
        })
        .catch(function(error) {
          console.log(error);
          if (error.response.status == 403) {
            self.logout();
          }
        });
    },

    fetchByCategory() {
      this.loading2 = true;
      var self = this;
      axios
        .get(
          "https://api-dash.bniservicerating.com/v1/rating/category-chart?startdate=" +
            moment(this.daterange[0]).format("YYYY-MM-DD") +
            "&enddate=" +
            moment(this.daterange[1]).format("YYYY-MM-DD") +
            "&outlet_code=" +
            this.params.outlet +
            "&branch_code=" +
            this.params.branch +
            "&region_code=" +
            this.params.region,
          {
            headers: {
              "x-api-key": "DBrbsrGFyoDFGI8XS1lDUhhL1W0XfkDmpnfAcrt",
              "x-access-token": localStorage.getItem("accessToken"),
            },
          }
        )
        // api.getByCategory(this.params.region, this.params.branch, this.params.outlet, moment(this.daterange[0]).format('YYYY-MM-DD'), moment(this.daterange[1]).format('YYYY-MM-DD'))
        .then(function(response) {
          var data = [
            [
              "Name",
              "Positive",
              { type: "string", role: "annotation", p: { html: true } },
              "Negative",
              { type: "string", role: "annotation", p: { html: true } },
            ],
          ];
          if (response.data.data.length > 0) {
            response.data.data.forEach((element) => {
              data.push([
                element.name.toUpperCase(),
                parseInt(element.positive),
                parseInt(element.positive),
                parseInt(element.negative),
                parseInt(element.negative),
              ]);
            });
            // self.rows = data
            self.chartOptions2.width = "100%";
            self.chartData2 = data;
          } else {
            data.push(["No data", 0, 0]);
            self.chartData2 = data;
          }
          self.loading2 = false;
        })
        .catch(function(error) {
          console.log(error);
          self.loading2 = false;
          if (error.response.status == 403) {
            self.logout();
          }
        });
    },

    fetchByFacility() {
      this.loading_facility_chart = true;
      var self = this;
      axios
        .get(
          "https://api-dash.bniservicerating.com/v1/rating/facility-chart?startdate=" +
            moment(this.daterange[0]).format("YYYY-MM-DD") +
            "&enddate=" +
            moment(this.daterange[1]).format("YYYY-MM-DD") +
            "&outlet_code=" +
            this.params.outlet +
            "&branch_code=" +
            this.params.branch +
            "&region_code=" +
            this.params.region,
          {
            headers: {
              "x-api-key": "DBrbsrGFyoDFGI8XS1lDUhhL1W0XfkDmpnfAcrt",
              "x-access-token": localStorage.getItem("accessToken"),
            },
          }
        )
        // api.getByCategory(this.params.region, this.params.branch, this.params.outlet, moment(this.daterange[0]).format('YYYY-MM-DD'), moment(this.daterange[1]).format('YYYY-MM-DD'))
        .then(function(response) {
          console.log(response);
          var data = [
            [
              "Name",
              "Positive",
              { type: "string", role: "annotation", p: { html: true } },
              "Negative",
              { type: "string", role: "annotation", p: { html: true } },
            ],
          ];
          if (response.data.data.length > 0) {
            response.data.data.forEach((element) => {
              data.push([
                element.name.toUpperCase(),
                parseInt(element.positive),
                parseInt(element.positive),
                parseInt(element.negative),
                parseInt(element.negative),
              ]);
            });
            // self.rows = data
            self.facilityChartOptions.width = "100%";
            self.facilityChartData = data;
          } else {
            data.push(["No data", 0, 0]);
            self.facilityChartData = data;
          }
          self.loading_facility_chart = false;
        })
        .catch(function(error) {
          console.log(error);
          self.loading_facility_chart = false;
          if (error.response.status == 403) {
            self.logout();
          }
        });
    },

    fetchByAspect() {
      this.loading_aspect_chart = true;
      var self = this;
      axios
        .get(
          "https://api-dash.bniservicerating.com/v1/rating/aspect-chart?startdate=" +
            moment(this.daterange[0]).format("YYYY-MM-DD") +
            "&enddate=" +
            moment(this.daterange[1]).format("YYYY-MM-DD") +
            "&outlet_code=" +
            this.params.outlet +
            "&branch_code=" +
            this.params.branch +
            "&region_code=" +
            this.params.region,
          {
            headers: {
              "x-api-key": "DBrbsrGFyoDFGI8XS1lDUhhL1W0XfkDmpnfAcrt",
              "x-access-token": localStorage.getItem("accessToken"),
            },
          }
        )
        .then(function(response) {
          console.log(response);
          var data = [
            [
              "Name",
              "Positive",
              { type: "string", role: "annotation", p: { html: true } },
              "Negative",
              { type: "string", role: "annotation", p: { html: true } },
            ],
          ];
          if (response.data.data.length > 0) {
            response.data.data.forEach((element) => {
              data.push([
                element.name.toUpperCase(),
                parseInt(element.positive),
                parseInt(element.positive),
                parseInt(element.negative),
                parseInt(element.negative),
              ]);
            });
            // self.rows = data
            self.aspectChartOptions.width = "100%";
            self.aspectChartData = data;
          } else {
            data.push(["No data", 0, 0]);
            self.aspectChartData = data;
          }
          self.loading_aspect_chart = false;
        })
        .catch(function(error) {
          console.log(error);
          self.loading_aspect_chart = false;
          if (error.response.status == 403) {
            self.logout();
          }
        });
    },

    fetchRegions() {
      this.loading = true;
      var self = this;
      regions
        .getAll()
        .then(function(response) {
          //
          var regionsx = [];
          response.data.data.forEach((element) => {
            regionsx.push({
              id: element.code,
              text: element.name,
            });
          });
          self.regions = regionsx;
          // console.log(self.regions)
        })
        .catch(function(error) {
          console.log(error);
          if (error.response.status == 403) {
            self.logout();
          }
        });
    },
    fetchBranches() {
      var self = this;
      branches
        .getAll(this.params.region)
        .then(function(response) {
          //
          var regionsx = [];
          response.data.data.forEach((element) => {
            regionsx.push({
              id: element.code,
              text: element.name,
            });
          });
          self.branches = regionsx;
          // console.log(self.branches)
        })
        .catch(function(error) {
          console.log(error);
          if (error.response.status == 403) {
            self.logout();
          }
        });
    },
    fetchOutlets() {
      var self = this;
      outlets
        .getAll(this.params.region, this.params.branch)
        .then(function(response) {
          //
          var regionsx = [];
          response.data.data.forEach((element) => {
            regionsx.push({
              id: element.code,
              text: element.name,
            });
          });
          self.outlets = regionsx;
          // console.log(self.branches)
        })
        .catch(function(error) {
          console.log(error);
          if (error.response.status == 403) {
            self.logout();
          }
        });
    },
    myChangeEvent(val) {
      console.log(val);
      this.params.region = val;
      this.params.branch = "";
      this.params.outlet = "";
      this.branches = [];
      this.fetchBranches();
      this.fetch();
      this.fetchByCategory();
      this.fetchByFacility();
      this.fetchByAspect();
      this.fetchGeneral();
      this.fetchNegativeReview();
    },
    myChangeEvent2(val) {
      console.log(val);
      this.params.branch = val;
      this.params.outlet = "";
      this.fetch();
      this.fetchByCategory();
      this.fetchByFacility();
      this.fetchByAspect();
      this.fetchOutlets();
      this.fetchGeneral();
      this.fetchNegativeReview();
    },
    myChangeEvent3(val) {
      console.log(val);
      this.params.outlet = val;
      this.fetch();
      this.fetchByCategory();
      this.fetchByFacility();
      this.fetchByAspect();
      this.fetchGeneral();
      this.fetchNegativeReview();
    },
    dateChanged() {
      console.log(this.daterange);
      this.fetch();
      this.fetchByCategory();
      this.fetchByFacility();
      this.fetchByAspect();
      this.fetchGeneral();
      this.fetchNegativeReview();
    },
    reset() {
      this.branches = [];
      this.outlets = [];
      this.params = {
        region: "",
        branch: "",
        outlet: "",
      };
      this.fetch();
      this.fetchByCategory();
      this.fetchByFacility();
      this.fetchByAspect();
      this.fetchNegativeReview();
    },

    chartClicked(val) {
      console.log(val);
    },
  },
};

// https://api-dash.bniservicerating.com/v1/rating/aspect-chart?startdate=2021-03-01&enddate=2021-05-01&outlet_code=&branch_code=&region_code=
</script>

<style lang="scss" scoped>
.custom_toolbar {
  display: flex;
  div {
    margin-right: 10px;
  }
}
.custom_toolbar_mini {
  div {
    margin-right: 10px;
  }
}
.el-date-editor .el-range-separator {
  width: 22px !important;
}

.negative-review-chart-warpper {
  margin-top: 1em;
}
</style>
